import { request } from '@/utils/request';

// ==================== 通用接口 ====================

/**
 * 获取国家/地区列表
 * @returns {Promise<{ code: number, data: Array<{id: number, name: string, status: number, created_at: string, updated_at: string}>, message: string }>}
 */
export const getCountryList = () => request.get('/admin/common/country');

/**
 * 获取国家列表（多语言）
 * @param {Object} [params] - 查询参数
 * @param {number} [params.is_hot] - 是否热门国家（1:是 0:否）
 * @returns {Promise<{ code: number, data: Array<{id: number, name: string, translations: {"zh-CN": string, "zh-TW": string, "en-US": string, "ja": string}}>, message: string }>}
 */
export const getCountries = params => request.get('/admin/common/countries', { params });

/**
 * 获取支持的语言列表
 * @returns {Promise<{ code: number, data: Array<{ code: string, name: string, is_default: number }>, message: string }>}
 */
export const getSupportedLanguages = () => request.get('/admin/common/languages');
